/*
 *  Blog header section
 *    part of blog template
 *
 *  Version:
 *    1.0.0 - 2019/07/30
 */

import { CarouselSection } from './../carousel/CarouselSection';
import { register } from './../ShopifySection';
import * as ResponsiveSizes from './../../settings/Responsive';

export const SELECTOR_CONTAINER = '[data-blog-header]';
export const SELECTOR_CAROUSEL = '[blog-tag-carousel]';

export const SELECTOR_DESC_FULL = 'data-blog-desc-full'
export const SELECTOR_DESC_LESS = 'data-blog-desc-less'
export const SELECTOR_DESC_BODY = '[data-blog-desc-body]'

export const BUTTON_READ_MORE = '[data-read-more]';
export const BUTTON_READ_LESS = '[data-read-less]';


export const CLASS_HIDDEN = 'is-hidden';
export const CLASS_EXPAND = 'is-expanded';

export class BlogHeader extends CarouselSection {
  constructor(container) {
    super(container);

    this.blogCarousel = container.find(SELECTOR_CAROUSEL);

    // events
    container.on('click touchend', BUTTON_READ_MORE, e => this.onClickReadMoreButton(e));
    container.on('click touchend', BUTTON_READ_LESS, e => this.onClickReadMoreButton(e));

    this.slick = this.initCarousel(this.blogCarousel);
  }
  optionOverrides() {
    return {
      adaptiveHeight: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: ResponsiveSizes.xsmall-1,
          settings: { slidesToShow: 3, slidesToScroll: 3 }
        },
        {
          breakpoint: ResponsiveSizes.small-1,
          settings: "unslick"
        }
      ]
    }
  }

  onClickReadMoreButton(e){
    e.stopPropagation();
    e.preventDefault();
    

    let self = $(e.currentTarget);


    // get full content
    let fullContent = self.closest('['+SELECTOR_DESC_FULL+']');
    fullContent = fullContent.attr(SELECTOR_DESC_FULL);

    // get shot content
    let lessContent = self.closest('['+SELECTOR_DESC_LESS+']');
    lessContent = lessContent.attr(SELECTOR_DESC_LESS);

    let contentBody = self.closest(SELECTOR_DESC_BODY);

    this.moreButton = contentBody.find(BUTTON_READ_MORE);
    this.lessButton = contentBody.find(BUTTON_READ_LESS);

    // toggle classes
    contentBody.toggleClass(CLASS_EXPAND);
    this.moreButton.toggleClass(CLASS_HIDDEN);
    this.lessButton.toggleClass(CLASS_HIDDEN);

    // on first click expand content
    if (!contentBody.hasClass(CLASS_EXPAND)) {
      // if content is less
      contentBody.html(lessContent);
      contentBody.find('p:last-child').append(this.moreButton);
      contentBody.find('p:last-child').append(this.lessButton);
      return;
    }
    // content more
    contentBody.html(fullContent);
    contentBody.find('p:last-child').append(this.moreButton);
    contentBody.find('p:last-child').append(this.lessButton);
  }

}

register(SELECTOR_CONTAINER, BlogHeader);
